// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProductInfo_Container__trLb6","Title":"ProductInfo_Title__CG2_Z","Info":"ProductInfo_Info__quLZc"};